module.exports = __webpack_public_path__ + "img/-LV558DPQx2DJx-12WmC.dcddd0f3.jpg";